<template>
    <div class="mask">
        <div class="inner-mask">
            <div class="ic-novideo">
                <img src="@/assets/icons/novideo.png" alt="noVideo" />
            </div>
            <div class="text-message">
                This Browser does not support the video. Please Use Chrome or Mozilla. 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>
<style scoped>
.mask {
	height: 45px;
	width: 100%;
    text-align: center;
	background-color: #1F2228;
	box-shadow: 0 3px 6px 0 rgba(0,0,0,0.11);
}
.inner-mask{
    padding: 1% 2% 1% 2%;
    display: inline-flex;
}
.ic-novideo img {
	height: 30px;
    width: 30px;
}
.text-message{
	color: #FFFFFF;
    font-family: "ProximanovaRegular";
    font-size: 8px;
    line-height: 30px;
    margin-left: 1%;
    white-space: nowrap;
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .text-message{
    font-size: 15px;
}
}

</style>


// WEBPACK FOOTER //
// src/components/Header-prompt/BrowserDetect.vue